<template>
  <div class="w-screen flex flex-col bg" style="min-height:100vh">
    <Header class="h-10" selected="custom"/>
    <div class="p-2 flex justify-center">
      <VTabs :tabs="featureTabs.tabs" @change="(item)=> featureTabs.select(item) " />
    </div>
    <GradientCreator v-if="featureTabs.isSelected('Gradient')" />
    <BoxShadowCreator v-if="featureTabs.isSelected('Box Shadow')" />
    <BorderRadiusCreator v-if="featureTabs.isSelected('Border Radius')" />
    <TypographyCreator v-if="featureTabs.isSelected('Typography')" />
  </div>
</template>

<script>
// @ is an alias to /src
import { UUID, UiSelect, UiTabs } from "@/util";
import { mapState, mapGetters, mapActions } from "vuex";
import firebase, { firestore } from "firebase";
import { AppService, Gradient, GradientColor } from "../store";
import { Component } from "../store/models/component.model";
import ColorPicker from "vue-color-picker-wheel";
import Vue from "vue";

export default {
  name: "Custom",
  components: {
    ColorPicker
  },
  data() {
    return {
      featureTabs: new UiTabs([
        "Gradient",
        "Box Shadow",
        "Border Radius",
        "Typography"
      ])
    };
  },
  mounted() {
    this.featureTabs.select('Gradient');
  },
  computed: {},
  methods: {}
};
</script>

<style scoped>
.grad {
  background: linear-gradient(90deg, red 0%, blue 50%, green 100%);
}
</style>